import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入 Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'

import { RecycleScroller } from "vue-virtual-scroller";

/* 解决 ResizeObserver loop completed with undelivered notifications 报错 */
// 1. 防抖处理
const debounce = (fn, delay) => {
  let timer = null
  return function () {
    let context = this
    let args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args)
    }, delay)
  }
}

const _ResizeObserver = window.ResizeObserver
if (_ResizeObserver) {
  window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
      callback = debounce(callback, 16)
      super(callback)
    }
  }
}

// 2. 全局错误拦截，防止错误弹窗
const ignoreErrors = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded'
]
const onError = (e) => {
  if (e && ignoreErrors.includes(e.message)) {
    e.stopImmediatePropagation()
    e.preventDefault()
    return true
  }
}
window.addEventListener('error', onError, true) // 使用捕获阶段
window.onerror = function(msg) {
  if (ignoreErrors.includes(msg)) {
    return true
  }
}

Vue.config.productionTip = false;
Vue.component("RecycleScroller", RecycleScroller);

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

// 开发与生产均生效：全局修正包含双协议的图片地址，避免出现 https://domain/http://domain/...
;(function installGlobalImgUrlNormalizer() {
  const hasDoubleProto = url => /(https?:\/\/)[\s\S]*?(https?:\/\/)/i.test(url || '')
  const normalize = url => {
    if (!url) return url
    let raw = String(url).trim().replace(/^@+/, '')
    if (hasDoubleProto(raw)) {
      const lastHttp = raw.toLowerCase().lastIndexOf('http://')
      const lastHttps = raw.toLowerCase().lastIndexOf('https://')
      const lastIdx = Math.max(lastHttp, lastHttps)
      if (lastIdx > -1) raw = raw.slice(lastIdx)
    }
    return raw
  }

  const tryFixImg = img => {
    if (!img || img.tagName !== 'IMG') return
    const src = img.getAttribute('src')
    if (!src) return
    const fixed = normalize(src)
    if (fixed && fixed !== src) {
      img.setAttribute('src', fixed)
    }
  }

  // 初次遍历
  Array.prototype.forEach.call(document.images || [], tryFixImg)

  // 监听属性与子树变化
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.target && m.target.tagName === 'IMG' && m.attributeName === 'src') {
        tryFixImg(m.target)
      } else if (m.type === 'childList') {
        m.addedNodes && m.addedNodes.forEach(node => {
          if (node && node.tagName === 'IMG') tryFixImg(node)
          if (node && node.querySelectorAll) {
            node.querySelectorAll('img').forEach(img => tryFixImg(img))
          }
        })
      }
    }
  })
  observer.observe(document.documentElement || document.body, {
    attributes: true,
    attributeFilter: ['src'],
    subtree: true,
    childList: true,
  })
})()



// 全局抑制 V2NIMError forbidden 在页面上展示（开发与生产均有效）
;(function installNimForbiddenSuppressor() {
  const nimForbidden = /(V2NIMError|forbidden)/i
  const matchesNim = input => {
    if (!input) return false
    if (typeof input === 'string') return nimForbidden.test(input)
    const text = input && (input.message || input.toString())
    return nimForbidden.test(text || '')
  }
  window.addEventListener('error', e => {
    if (matchesNim(e && e.error) || matchesNim(e && e.message)) {
      e.stopImmediatePropagation()
    }
  })
  window.addEventListener('unhandledrejection', e => {
    if (matchesNim(e && e.reason)) {
      e.preventDefault()
    }
  })
})()

// 抑制浏览器/扩展产生的“Could not establish connection. Receiving end does not exist”噪声
;(function suppressExtensionConnectError() {
  const re = /Could not establish connection\. Receiving end does not exist/i
  const hit = v => {
    if (!v) return false
    const t = typeof v === 'string' ? v : (v.message || v.reason || String(v))
    return re.test(t || '')
  }
  window.addEventListener('error', e => {
    if (hit(e && (e.error || e.message))) {
      e.stopImmediatePropagation()
    }
  })
  window.addEventListener('unhandledrejection', e => {
    if (hit(e && e.reason)) {
      e.preventDefault()
    }
  })
})()
